const Permission = () =>
  import(
    /* webpackChunkName: "security-permission" */ '@/pages/security/permission'
  )

export default {
  path: 'permission',
  meta: {
    label: 'permission',
    auth: 'permission'
  },
  component: {
    name: 'Permission',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'SecurityPermissionReport',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Permission
    }
  ]
}
